import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ElementRef,
  forwardRef,
  AfterViewChecked
} from '@angular/core';
import { ToolBarToolComponent } from '@progress/kendo-angular-toolbar';

export function outerWidth(element: any): number {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);

    width += (parseFloat(style.marginLeft) || 0 + parseFloat(style.marginRight) || 0);
    return width;
}

@Component({
    providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => SubscriptionButtonComponent) }],
    selector: 'subscription-button',
    template: `
      <ng-template #toolbarTemplate>
          <div class='subscription-button' style='width:18px; height:100%; position:relative;' #toolbarElement>
            <span class="pro-box" title="subscription feature" style='left:-20px; top:-10px; position:absolute;'></span>                
          </div>
      </ng-template>
  `,
    standalone: false
})
export class SubscriptionButtonComponent extends ToolBarToolComponent implements AfterViewChecked {
  public tabindex = -1;

  //@Input() public text: string;

  @ViewChild('toolbarTemplate', {static: true}) public toolbarTemplate: TemplateRef<any>;
  @ViewChild('toolbarElement') public toolbarElement: ElementRef<HTMLDivElement>;

  constructor() {
      super();
  }

  ngAfterViewChecked(): void {
    if (this.toolbarElement) {
      const parent = this.toolbarElement.nativeElement.parentElement;
      parent.classList.add(`subscription`);
      const sibling = parent.nextElementSibling;
      if (sibling) {
        sibling.classList.add(`subscription`);
      }
    }
  }

  public get outerWidth(): number {
      if (this.toolbarElement) {
          return outerWidth(this.toolbarElement.nativeElement);
      }
  }

  public canFocus(): boolean {
      return false; // marks the tools as focusable
  }

  // public focus(): void {
  //     // manage the roving tabindex
  //     // see https://www.w3.org/TR/wai-aria-practices/#kbd_roving_tabindex
  //     this.tabindex = 0;
  //     // focus the focusable element
  //     this.button.nativeElement.focus();
  // }

  public handleKey(): boolean {
      // manage the roving tabindex
      // see https://www.w3.org/TR/wai-aria-practices/#kbd_roving_tabindex
      this.tabindex = -1;
      // tell the toolbar that the focus can move to the next/prev focusable tool
      return false;
  }
}
